import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import Exam from './routes/Exam';

const LazyGuard = React.lazy(
	() => import(/* webpackChunkName: 'StudentHomeGuard' */ './Guard')
);

const LazyStudentCurriculum = React.lazy(
	() => import(/* webpackChunkName: 'StudentCurriculum' */ './components')
);

export default () => {
	return {
		path: ':curriculumId',
		element: <AsyncLoading component={<LazyGuard />} />,
		children: [
			{
				index: true,
				element: <AsyncLoading component={<LazyStudentCurriculum />} />,
			},
			...Exam(),
		],
	};
};
